// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-padding {
  padding: 12px;
}

.ion-margin {
  margin: 12px;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-default);
}

swiper-slide {
  width: 100% !important;
}

.image-wrapper {
  width: 100%;
  position: relative;
}
.image-wrapper ion-img {
  aspect-ratio: 373/257;
  border-radius: 2px;
  overflow: hidden;
  object-fit: contain;
}
.image-wrapper .default-img {
  background-color: #fff;
  padding: 15px;
}
.image-wrapper .info-product-icon {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
}
.image-wrapper .img-info {
  position: absolute;
  bottom: -16px;
  right: 3%;
  font-family: AppFont;
  font-size: 11px;
  color: var(--ion-color-danger);
}
@media (max-width: 992px) {
  .image-wrapper .img-info {
    font-size: 9px;
  }
}

.slide-col {
  top: 0;
  bottom: 80px;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
}

.option-group-col {
  flex-shrink: 1;
  flex-basis: auto;
  margin-top: 10px;
  padding: 0 11px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-btn {
  cursor: pointer;
  position: absolute;
  margin: 0;
  font-size: 40px;
  top: 10px;
  left: 10px;
  z-index: 1;
}

ion-toolbar {
  --ion-toolbar-color: white;
  --ion-toolbar-background: var(--ion-color-primary);
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  height: 36px;
  width: 36px;
  padding: 8px;
}

.menge {
  margin-inline: 16px;
  padding: 12px 0 !important;
  border-top: 0.5px solid #c9c9c9;
  border-bottom: 0.5px solid #c9c9c9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge .quantity {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 21.8px;
  text-align: left;
  color: var(--ion-color-primary-text);
}

.select-size {
  text-align: left;
  padding: 10px 25px !important;
  display: flex;
  flex-direction: column;
}
.select-size ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.info {
  text-align: left;
  padding: 24px 16px !important;
}
.info .title {
  margin: 0px 0px 12px;
  font-family: AppFontSemiBold;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  text-align: left;
  color: var(--ion-color-primary-text);
}
.info .desc {
  font-size: 14px;
  line-height: 128%;
  letter-spacing: 0;
  color: var(--color-grey);
}
.info .measurement {
  font-size: 12px;
  line-height: 110%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title > span {
  display: inline-flex;
  align-items: center;
}

.info-icon {
  margin-left: 5px;
  position: relative;
  left: unset;
  right: unset;
  bottom: unset;
  top: unset;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.qty-row {
  margin: 10px 0;
}
.qty-row h2 {
  font-size: 18px;
}

.size-picker {
  margin-top: 20px;
}
.size-picker .chip {
  background: #f5f5f5;
  color: #000;
}
.size-picker .chip.selected {
  background: #000;
  color: #fff;
  font-weight: 500;
}

.step-counter {
  color: var(--ion-color-primary);
}

.first-toolbar {
  padding: 12px;
  backdrop-filter: blur(3px);
  color: black;
}

.option-group-description {
  margin: 20px 16px 0;
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: var(--ion-color-primary-text);
}

.first-page-header {
  background: red;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
}
.first-page-header ion-icon {
  zoom: 1.7;
  margin: 0px 5px;
  width: 8%;
}
.first-page-header ion-title {
  text-align: left;
}

.button-price {
  margin-left: 10px;
}

.header-block {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.header-block ion-icon {
  zoom: 0.6;
}

app-tag {
  margin-bottom: 12px;
}

ion-item {
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

.footer-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 80px;
  width: 100%;
  z-index: 999;
  background: white;
  padding: 16px;
}

app-universal-page-toolbar {
  --title-width: 192px;
}

.error-message {
  font-size: 12px;
  margin: 0;
  margin-left: 16px;
  margin-top: 6px;
  text-align: start;
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAIA;EACC,aAAA;AAHD;;AAMA;EACC,YAAA;AAHD;;AAMA;EACC,aAAA;EACA,kBAAA;AAHD;;AAMA;EACC,sBAAA;EACA,uBAAA;EACA,2CAAA;AAHD;;AAMA;EACC,sBAAA;AAHD;;AAMA;EACC,WAAA;EACA,kBAAA;AAHD;AAIC;EACC,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AASC;EACC,sBAAA;EACA,aAAA;AAPF;AAUC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AARF;AAWC;EACC,kBAAA;EACA,aAAA;EACA,SAAA;EAEA,oBAAA;EACA,eAAA;EACA,8BAAA;AAVF;AC3CE;ED8CD;IAUE,cAAA;EATD;AACF;;AAaA;EACC,MAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,iCAAA;EAEA,gBAAA;AAXD;;AAcA;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAXD;;AAcA;EACC,YAAA;EACA,cAAA;AAXD;;AAcA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAXD;;AAcA;EACC,0BAAA;EACA,kDAAA;AAXD;AAaC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAXF;AAcC;EACC,YAAA;EACA,WAAA;EACA,YAAA;AAZF;;AAeA;EACC,mBAtHgB;EAuHhB,0BAAA;EACA,+BAAA;EACA,kCAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAbD;AAeC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;AAbF;;AAgBA;EACC,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;AAbD;AAcC;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAZF;;AAeA;EACC,gBAAA;EACA,6BAAA;AAZD;AAcC;EACC,oBAAA;EAEA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,gBAAA;EAEA,oCAAA;AAfF;AAkBC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;AAhBF;AAmBC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;;AAqBA;EACC,oBAAA;EACA,mBAAA;AAlBD;;AAqBA;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAlBD;;AAqBA;EACC,cAAA;AAlBD;AAoBC;EACC,eAAA;AAlBF;;AAsBA;EACC,gBAAA;AAnBD;AAqBC;EACC,mBAAA;EACA,WAAA;AAnBF;AAqBE;EACC,gBAAA;EACA,WAAA;EACA,gBAAA;AAnBH;;AAwBA;EACC,+BAAA;AArBD;;AAwBA;EACC,aAAA;EACA,0BAAA;EACA,YAAA;AArBD;;AAwBA;EACC,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;AAtBD;;AAyBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAtBD;AAuBC;EACC,SAAA;EACA,eAAA;EACA,SAAA;AArBF;AAuBC;EACC,gBAAA;AArBF;;AAwBA;EACC,iBAAA;AArBD;;AAuBA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AApBD;AAqBC;EACC,SAAA;AAnBF;;AAsBA;EACC,mBAAA;AAnBD;;AAqBA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;AAlBD;;AAqBA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAlBD;;AAwBA;EACC,oBAAA;AArBD;;AAwBA;EACC,eAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AArBD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n$padding-inline: 16px;\n\n.ion-padding {\n\tpadding: 12px;\n}\n\n.ion-margin {\n\tmargin: 12px;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--background-default);\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\n.image-wrapper {\n\twidth: 100%;\n\tposition: relative;\n\tion-img {\n\t\taspect-ratio: 373 / 257;\n\t\tborder-radius: 2px;\n\t\toverflow: hidden;\n\t\tobject-fit: contain;\n\n\t\t&:not(.default-img) {\n\t\t\t// object-fit: cover;\n\t\t}\n\t}\n\n\t.default-img {\n\t\tbackground-color: #fff;\n\t\tpadding: 15px;\n\t}\n\n\t.info-product-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 6px;\n\t}\n\n\t.img-info {\n\t\tposition: absolute;\n\t\tbottom: -16px;\n\t\tright: 3%;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 11px;\n\t\tcolor: var(--ion-color-danger);\n\n\t\t@include mobile {\n\t\t\tfont-size: 9px;\n\t\t}\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 80px;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\t-webkit-overflow-scrolling: touch;\n\n\toverflow-y: auto;\n}\n\n.option-group-col {\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tmargin-top: 10px;\n\tpadding: 0 ($padding-inline - 5px);\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\tmargin: 0;\n\tfont-size: 40px;\n\ttop: 10px;\n\tleft: 10px;\n\tz-index: 1;\n}\n\nion-toolbar {\n\t--ion-toolbar-color: white;\n\t--ion-toolbar-background: var(--ion-color-primary);\n\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tpadding: 8px;\n\t}\n}\n.menge {\n\tmargin-inline: $padding-inline;\n\tpadding: 12px 0 !important;\n\tborder-top: 0.5px solid #c9c9c9;\n\tborder-bottom: 0.5px solid #c9c9c9;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.quantity {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 18px;\n\t\tline-height: 21.8px;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary-text);\n\t}\n}\n.select-size {\n\ttext-align: left;\n\tpadding: 10px 25px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tion-item {\n\t\tborder-radius: 5px;\n\t\tmargin-top: 10px;\n\t\tborder: 0.5px solid #e2dcd5;\n\t}\n}\n.info {\n\ttext-align: left;\n\tpadding: 24px $padding-inline !important;\n\n\t.title {\n\t\tmargin: 0px 0px 12px;\n\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 26px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-transform: uppercase;\n\n\t\ttext-align: left;\n\n\t\tcolor: var(--ion-color-primary-text);\n\t}\n\n\t.desc {\n\t\tfont-size: 14px;\n\t\tline-height: 128%;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--color-grey);\n\t}\n\n\t.measurement {\n\t\tfont-size: 12px;\n\t\tline-height: 110%;\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.title > span {\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.info-icon {\n\tmargin-left: 5px;\n\tposition: relative;\n\tleft: unset;\n\tright: unset;\n\tbottom: unset;\n\ttop: unset;\n\twidth: 30px;\n\theight: 30px;\n\tcursor: pointer;\n}\n\n.qty-row {\n\tmargin: 10px 0;\n\n\th2 {\n\t\tfont-size: 18px;\n\t}\n}\n\n.size-picker {\n\tmargin-top: 20px;\n\n\t.chip {\n\t\tbackground: #f5f5f5;\n\t\tcolor: #000;\n\n\t\t&.selected {\n\t\t\tbackground: #000;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n\n.step-counter {\n\tcolor: var(--ion-color-primary);\n}\n\n.first-toolbar {\n\tpadding: 12px;\n\tbackdrop-filter: blur(3px);\n\tcolor: black;\n}\n\n.option-group-description {\n\tmargin: 20px $padding-inline 0;\n\n\tfont-family: AppFontBold;\n\tfont-size: 18px;\n\tline-height: 100%;\n\tletter-spacing: -0.01em;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-primary-text);\n}\n\n.first-page-header {\n\tbackground: red;\n\theight: 60px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: white;\n\twidth: 100%;\n\tion-icon {\n\t\tzoom: 1.7;\n\t\tmargin: 0px 5px;\n\t\twidth: 8%;\n\t}\n\tion-title {\n\t\ttext-align: left;\n\t}\n}\n.button-price {\n\tmargin-left: 10px;\n}\n.header-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: start;\n\tion-icon {\n\t\tzoom: 0.6;\n\t}\n}\napp-tag {\n\tmargin-bottom: 12px;\n}\nion-item {\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\n\n.footer-container {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 80px;\n\twidth: 100%;\n\tz-index: 999;\n\tbackground: white;\n\tpadding: 16px;\n}\n\n.footer-button {\n}\n\napp-universal-page-toolbar {\n\t--title-width: 192px;\n}\n\n.error-message {\n\tfont-size: 12px;\n\tmargin: 0;\n\tmargin-left: 16px;\n\tmargin-top: 6px;\n\ttext-align: start;\n\tcolor: var(--ion-color-danger);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
